import { Visibility, VisibilityOff } from "@material-ui/icons";
import { IconButton, InputAdornment } from "@mui/material";
import { useState } from "react";
import { TextValidator } from "react-material-ui-form-validator";

const TextValidatorPassword = ({
  value,
  onChange,
  required,
  className,
  name,
  autocomplete,
  label,
  disabled,
  placeholder,
  strongValidate = true,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <TextValidator
      variant="outlined"
      className={className}
      placeholder={placeholder || "Mật khẩu"}
      label={label}
      name={name}
      fullWidth
      disabled={disabled}
      value={value}
      onChange={onChange}
      autoComplete={autocomplete || "new-password"}
      validators={[
        ...(required ? ["required"] : []),
        ...(strongValidate
          ? [
              "matchRegexp:[A-Z]",
              "matchRegexp:[a-z]",
              "matchRegexp:\\d",
              "matchRegexp:.*[\\W_]+.*",
              "matchRegexp:^.{8,}$",
            ]
          : []),
      ]}
      errorMessages={[
        ...(required ? ["Không được để trống"] : []),
        ...(strongValidate
          ? [
              `Phải chứa ít nhất 1 ký tự viết hoa`,
              "Phải chứa ít nhất 1 ký tự viết thường",
              "Phải chứa ít nhất 1 số",
              "Phải chứa ít nhất 1 ký tự đặc biệt",
              "Ít nhất 8 ký tự",
            ]
          : []),
      ]}
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleShowPassword}>
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default TextValidatorPassword;
